import React, {useState} from 'react';
import '../SettingsPage.scss';
import {InputField} from "../../../components/input-field/InputField";
import {api} from "../../../hooks/useFetch";

const Password = () => {
	const [oldPassword, setOldPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [confirmNewPassword, setConfirmNewPassword] = useState('');
	const [error, setError] = useState(''); // State for error message
	const [successMessage, setSuccessMessage] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	const handleUpdatePassword = async () => {
		setError(''); // Clear any previous errors
		setSuccessMessage('');
		setIsLoading(true);

		try {
			await api.post('/update-password', {  // Use api.post instead of AXIOS
				current_password: oldPassword,
				password: newPassword,
				password_confirmation: confirmNewPassword,
			});

			setSuccessMessage('Password updated successfully!'); // Display success message
			setOldPassword(''); // Clear the form fields
			setNewPassword('');
			setConfirmNewPassword('');

		} catch (e) {

			console.log('Updating password...', e);
			if (e.response && e.response.data && e.response.data.errors) {
				// Validation errors from Laravel
				const errorMessages = Object.values(e.response.data.errors).flat().join('\n');
				setError(errorMessages);
			} else {
				// Other server errors
				setError('An unexpected error occurred.');
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="password-section">
			<h2 className="password-section-title">Change Password</h2>
			<p className="password-section-description">Update your password for enhanced security.</p>

			{error && <div className="error-message">{error}</div>}
			{successMessage && <div className="success-message">{successMessage}</div>}

			<div className="form-group">
				<InputField
					label="Old Password"
					type="password"
					id="oldPassword"
					className="user-form__input"
					value={oldPassword}
					onChange={(e) => setOldPassword(e.target.value)}
				/>
			</div>

			<div className="form-group">
				<InputField
					label="New Password"
					type="password"
					id="newPassword"
					className="user-form__input"
					value={newPassword}
					onChange={(e) => setNewPassword(e.target.value)}
				/>
			</div>

			<div className="form-group">
				<InputField
					label="Confirmed New Password"
					type="password"
					id="confirmNewPassword"
					className="user-form__input"
					value={confirmNewPassword}
					onChange={(e) => setConfirmNewPassword(e.target.value)}
				/>
			</div>

			<button
				className="update-password-button"
				onClick={handleUpdatePassword}
				disabled={isLoading}
			>
				{isLoading ? 'Updating...' : 'Update Password'}
			</button>
		</div>
	);
};

export default Password;
